import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { map } from 'rxjs/operators'
import { Observable } from 'rxjs'
import { UserAdmin } from '../models/UserAdmin'
import { PATH } from '../app.api'
import { UserCreate } from '../models/User'
import { DemandsRequester, ReturnDemandsRequeste } from '../models/Requester'

@Injectable()
export class UserService {
	constructor(private http: HttpClient) {}

	public getUsers(data: {
		companyId: string,
		searchTruncated?: string,
		role?: string
	}): Observable<Array<UserCreate>> {

		const options: HttpHeaders = this.setHeader()

		let path = `${PATH}/user/list/${data.companyId}?`
		path = data.role ? `${path}role=${data.role}` : path
		path = data.searchTruncated ? `${path}${data.searchTruncated.substring(1)}` : path

		return this.http.get<any>(path, { headers: options }).pipe(
			map(result => {
				return result.content
			})
		)
	}

	public getMe() {
		const options: HttpHeaders = this.setHeader()

		return this.http.get<any>(`${PATH}/auth/me`, { headers: options })
	}

	public blockUsers(idsMongo: Array<string>): Observable<any> {
		const options: HttpHeaders = this.setHeader()

		return this.http.post<any>(`${PATH}/user/block`, idsMongo, { headers: options })
	}

	public unblockUsers(idsMongo: Array<string>): Observable<any> {
		const options: HttpHeaders = this.setHeader()

		return this.http.post<any>(`${PATH}/user/unblock`, idsMongo, { headers: options })
	}

	public getUser(id: string): Observable<UserAdmin> {
		const options: HttpHeaders = this.setHeader()

		return this.http.get<any>(`${PATH}/user/id/${id}`, { headers: options }).pipe(
			map(result => {
				return result.content
			})
		)
	}

	public addUser(user: UserCreate): Observable<any> {
		const options: HttpHeaders = this.setHeader()

		return this.http.post<any>(`${PATH}/user`, JSON.stringify(user), {
			headers: options
		})
	}

	public updatePersonalDetails(id: string, payload: UserAdmin): Observable<any> {
		const options: HttpHeaders = this.setHeader()

		return this.http.patch<any>(`${PATH}/user/me/change-data`, payload, {
			headers: options
		})
	}

	public patchUser(user: UserCreate): Observable<any> {
		const options: HttpHeaders = this.setHeader()

		return this.http.patch<any>(`${PATH}/user/${user._id}`, JSON.stringify(user), {
			headers: options
		})
	}

	public changeUserStatus(id: string): Observable<any> {
		const options: HttpHeaders = this.setHeader()

		return this.http.patch<any>(`${PATH}/user/change-status/${id}`, {
			headers: options
		})
	}

	public changeRequesterStatus(id: string): Observable<string> {
		const options: HttpHeaders = this.setHeader()

		return this.http.patch<any>(`${PATH}/requester-panel/change-status/${id}`, {
			headers: options
		}).pipe(
			map(result => {
				return result.message
			})
		)
	}

	public getDemandsForRequester(requesterId: string, skipDemands: number): Observable<ReturnDemandsRequeste> {
		const options: HttpHeaders = this.setHeader()

		return this.http.get<any>(`${PATH}/requester-panel/demands/${requesterId}/${skipDemands}`, {
			headers: options
		}).pipe(
			map(result => {
				return result
			})
		)
	}

	public sendEmail(email: string): Observable<any> {
		const options: HttpHeaders = this.setHeader()

		return this.http.patch<any>(`${PATH}/user/resendEmail/${email}`, {
			headers: options
		})
	}

	public changePassword(passwordObject: object): Observable<any> {
		const options: HttpHeaders = this.setHeader()

		return this.http.patch<any>(`${PATH}/user/me/change-password`, JSON.stringify(passwordObject), { headers: options })
	}

		private setHeader(): HttpHeaders {
			return new HttpHeaders({ 'Content-Type': 'application/json' }).append( 'x-source-from', 'PAINEL')
	}
}
